/// TYPES ///
import { IBreadcrumb } from "api/types/ui";
/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/ui";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/ui";

export const setBreadcrumbs = (crumbs: IBreadcrumb[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_CRUMBS,
      crumbs
    });
  }
}
